<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="createMode ? $t('clinic.Add-Room') : $t('clinic.Edit-Room')"
    >
      <b-card-text>
        <b-row>
          <b-col md="6">
            <b-form-group :label="$t('common.name')" label-for="name">
              <b-form-input
                v-model="EditForm.name"
                :placeholder="$t('common.name')"
              />
              <p class="text-danger mt-1">{{ errorForm.name }}</p>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <AutoComplete
              :label="$t('clinic.Floor')"
              :placeholder="$t('clinic.Floor')"
              v-model="EditForm.floor_id"
              :serializer="(val) => val.id"
              param-query="search"
              endpoint="floor"
              text-title="name"
            />
            <p class="text-danger mt-1">{{ errorForm.floor_id }}</p>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('common.price')" label-for="price">
              <b-form-input
                v-model="EditForm.price"
                type="number"
                :placeholder="$t('common.price')"
              />
              <p class="text-danger mt-1">{{ errorForm.price }}</p>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group :label="$t('common.type')" label-for="Type">
              <v-select
                v-model="EditForm.type"
                :options="['vip', 'standard']"
                :placeholder="$t('common.type')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <!-- <b-form-group
              :label="$t('clinic.Is-it-Surgery-Room')"
              label-for="Name"
            > -->
            <b-form-group
              :label="$t('clinic.Is-it-Surgery-Room')"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-radio
                v-model="EditForm.is_surgery_room"
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                :value="true"
                >{{ $t("common.yes") }}</b-form-radio
              >
              <b-form-radio
                v-model="EditForm.is_surgery_room"
                :aria-describedby="ariaDescribedby"
                name="some-radios"
                :value="false"
                >{{ $t("common.no") }}</b-form-radio
              >
            </b-form-group>
            <!-- <b-form-checkbox
                class="checkbox-visit"
                v-for="(option, index) in [
                  { text: $t('common.yes'), value: false },
                  { text: $t('common.no'), value: true },
                ]"
                v-model="EditForm.is_surgery_room"
                :key="index"
                :value="option.value"
                name="flavour-3a"
              >
                {{ option.text }}
              </b-form-checkbox> -->
            <!-- </b-form-group> -->
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{ $t('common.add') }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-card title="Rooms">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("clinic.Filter-Rooms") }}</h2>
            <br />
          </b-col>

          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.name')" label-for="Name">
              <b-form-input
                id="Name"
                v-model="roomNameFilter"
                :placeholder="$t('common.name')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4" cols="12">
            <AutoComplete
              :label="$t('clinic.Floor')"
              :placeholder="$t('clinic.Select-room')"
              v-model="floorFilter"
              :serializer="(val) => val.id"
              param-query="search"
              endpoint="floor"
              text-title="name"
            />
          </b-col>
          <b-col md="4" cols="12">
            <b-form-group
              :label="$t('clinic.Is-it-Surgery-Room')"
              label-for="Name"
            >
              <b-form-checkbox
                class="checkbox-visit"
                v-for="(option, index) in [
                  { text: $t('common.no'), value: false },
                  { text: $t('common.yes'), value: true },
                ]"
                v-model="isSurgeryFilter"
                :key="index"
                :value="option.value"
                name="flavour-3a"
              >
                {{ option.text }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getRoomsList()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("clinic.Rooms") }}</h2>
          <b-button
            variant="primary"
            @click="show(EditForm, 'create')"
            v-if="$store.state.app.permissions.includes('store-room')"
          >
            {{ $t("clinic.Add-Room") }}
          </b-button>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <!-- @click="printId(data.item.id)" -->

              <ActionsButtons
                deletePerm="delete-room"
                editPerm="update-room"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
              <!-- Dropdown -->
              <!-- <b-dropdown
                variant="link"
                toggle-class="p-0"
                no-caret
                :right="$store.state.appConfig.isRTL"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                <b-dropdown-item
                  @click="show(data.item)"
                  v-if="$store.state.app.permissions.includes('update-room')"
                >
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">Edit</span>
                </b-dropdown-item>
                <b-dropdown-item
                  @click="deleteModel(data.item)"
                  v-if="$store.state.app.permissions.includes('delete-room')"
                >
                  <feather-icon icon="TrashIcon" />
                  <span class="align-middle ml-50">Delete</span>
                </b-dropdown-item>
              </b-dropdown> -->
            </div>
          </template>
          <template #cell(is_surgery_room)="data">
            <div>
              <div v-if="data.item.is_surgery_room">
                {{ $t("common.yes") }}
              </div>
              <div v-else>{{ $t("common.no") }}</div>
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing 1 to 10 Rooms</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getRoomsList()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BFormCheckbox,
  BFormRadio,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BCardText,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";

const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import permissionChecker from "@/mixins/permissionChecker";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";

export default {
  mixins: [permissionChecker],

  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BFormCheckbox,
    vSelect,
    AutoComplete,
    ActionsButtons,
    DeleteModal,
    BFormRadio,
    BCardText,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        name: "",
        floor_id: "",
        type: "",
        price: "",
        is_surgery_room: false,
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        name: "",
        name: "",
        floor_id: "",
        type: "",
        price: "",
        is_surgery_room: false,
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        { key: "name", label: this.$t("common.name"), sortable: true },
        { key: "type", label: this.$t("common.type"), sortable: true },
        { key: "price", label: this.$t("common.price"), sortable: true },
        {
          key: "is_surgery_room",
          label: this.$t("clinic.Is-it-Surgery-Room"),
          sortable: true,
        },
        {
          key: "floor.name",
          label: this.$t("clinic.Floor"),
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      idRoom: "",
      roomNameFilter: "",
      floorFilter: "",
      isSurgeryFilter: null,
    };
  },
  mounted() {
    this.getRoomsList();
  },
  methods: {
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          name: "",
          type: "",
          price: "",
          floor_id: "",
          is_surgery_room: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;
        this.idRoom = item.id;
        // this.EditForm.id = item.id;
        this.EditForm.name = item.name;
        this.EditForm.type = item.type;
        this.EditForm.price = item.price;

        this.EditForm.floor_id = item.floor_id;
        this.EditForm.is_surgery_room = item.is_surgery_room;
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    async getRoomsList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/room?page=${this.page}&take=${this.take}&sort=-id&include=floor`;

      if (this.roomNameFilter) {
        url += `&filter[name]=${this.roomNameFilter}`;
      }
      if (this.floorFilter) {
        url += `&filter[floor_id]=${this.floorFilter}`;
      }
      if (typeof this.isSurgeryFilter == "boolean") {
        url += `&filter[is_surgery_room]=${this.isSurgeryFilter ? "1" : "0"}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/room/${this.deleteForm.id}`)
        .then((response) => {
          this.getRoomsList();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      this.loading = true;
      let count = 0;
      this.errorForm.name = "";
      this.errorForm.floor_id = "";
      this.errorForm.price = "";
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }
      console.log(
        this.EditForm.is_surgery_room,
        "this.EditForm.is_surgery_room"
      );
      if (!this.EditForm.is_surgery_room) {
        this.EditForm.is_surgery_room = 0;
      } else {
        this.EditForm.is_surgery_room = 1;
        this.EditForm.type = null;
      }
      if (!this.EditForm.name) {
        count++;
        this.errorForm.name = "The name field is required.";
      }
      if (!this.EditForm.floor_id) {
        count++;
        this.errorForm.floor_id = "The floor field is required.";
      }
      if (!this.EditForm.price) {
        count++;
        this.errorForm.price = "The price field is required.";
      }
      if (count > 0) {
        this.loading = false;
        return false;
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/room`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getRoomsList();
              this.$bvModal.hide("modal-edit");
              this.loading = false;
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        //  this.idRoom = this.EditForm.id;
        // delete this.EditForm.id;
        (this.params.form = this.EditForm),
          (this.params.path = `/room/${this.idRoom}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getRoomsList();
              this.$bvModal.hide("modal-edit");
              this.loading = false;
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
